import { Text, Tooltip } from "@mantine/core";
import type { TextProps } from "@mantine/core";
import { formatBps, formatLocalMinor, formatMicroUsdc } from "@/lib/format";

/** Render integer microUSDC as humanized USD. Tooltip shows the raw integer. */
export function Money({
  micro,
  ...rest
}: { micro: number | null | undefined } & TextProps) {
  if (micro === null || micro === undefined) {
    return (
      <Text span c="dimmed" {...rest}>
        —
      </Text>
    );
  }
  return (
    <Tooltip label={`${micro.toLocaleString()} microUSDC`} withArrow>
      <Text span ff="monospace" {...rest}>
        {formatMicroUsdc(micro)}
      </Text>
    </Tooltip>
  );
}

/** Local-currency minor units + ISO currency, e.g. merchant/local amount on a payment. */
export function LocalMoney({
  minor,
  currency,
}: {
  minor: number | null | undefined;
  currency: string | null | undefined;
}) {
  return (
    <Text span ff="monospace">
      {formatLocalMinor(minor, currency)}
    </Text>
  );
}

export function Bps({ bps }: { bps: number | null | undefined }) {
  return <Text span ff="monospace">{formatBps(bps)}</Text>;
}
